import { render, staticRenderFns } from "./OneEnterpriseArchivesJg.vue?vue&type=template&id=2fe6a030"
import script from "./OneEnterpriseArchivesJg.vue?vue&type=script&lang=js"
export * from "./OneEnterpriseArchivesJg.vue?vue&type=script&lang=js"
import style0 from "./OneEnterpriseArchivesJg.vue?vue&type=style&index=0&id=2fe6a030&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports